import axios from "axios";

export const userLogout = async (id) => {
  try {
    let payload = {id:id}
    let status = await axios.post(
      `${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/user/logout`,
      payload
    );
    return status;
  } catch (err) {
    console.log("error while update user  profile in  keyclock", err.message);
    return {
      message: "Server Not responding! plese try after some time",
      status: 409,
    };
  }
};
